import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PetInfoInput from './../../components/PetInfo/PetInfoInput';
import fetchPetInfoAction from './../../store/actions/fetch/fetchPetInfoAction';
import * as actionTypes from './../../store/actions/petInfoAction';
import * as actionTypesHelp from './../../store/actions/helpAction';
import PetInfoResourceType from './../../types/PetInfoResourceType';
import Loader from './../../components/Loader/Loader';

/**
 * PetInfo container
 */
class PetInfo extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, setPetName, setClinicRecordNumber, setMealsPerDay, defaultValues,
      clinicRecordNumber, mealsPerDay, petName, ready, openModalWithContent} = this.props;

    if (pending ||!ready) return (
      <Loader/>
    );

    return (
      <PetInfoInput
        data={data}
        petName={petName}
        setPetName={setPetName}
        clinicRecordNumber={clinicRecordNumber}
        setClinicRecordNumber={setClinicRecordNumber}
        mealsPerDay={mealsPerDay}
        setMealsPerDay={setMealsPerDay}
        openModalWithContent={openModalWithContent}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    error: state.petInfoReducer.error,
    data: state.petInfoReducer.data,
    pending: state.petInfoReducer.pending,
    petName: state.petInfoReducer.petName,
    clinicRecordNumber: state.petInfoReducer.clinicRecordNumber,
    mealsPerDay: state.petInfoReducer.mealsPerDay,
    ready: state.petInfoReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchPetInfoAction
      },
      dispatch,
    ),
    setPetName: (petName) => dispatch({
      type: actionTypes.SET_PET_NAME,
      petName: petName,
    }),
    setClinicRecordNumber: (clinicRecordNumber) => dispatch({
      type: actionTypes.SET_CLINIC_RECORD_NUMBER,
      clinicRecordNumber: clinicRecordNumber,
    }),
    setMealsPerDay: (mealsPerDay) => dispatch({
      type: actionTypes.SET_MEALS_PER_DAY,
      mealsPerDay: mealsPerDay,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    openModalWithContent: (key) => dispatch({
      type: actionTypesHelp.OPEN_MODAL_WITH_CONTENT,
      key: "MealsPerDay",
      open: true,
    }),
  }
};

PetInfo.propTypes = PetInfoResourceType;

export default connect(mapStateToProps, mapDispatchToProps)(PetInfo);
